import store from '@/store'
import { formatDate } from '@/helpers/date'

const entity = {
  absoluteKey: 'OrderBudgetGroupingFlight',
  module: 'orderFlight',
  parentModule: 'order',
  key: 'OrderFlight',
  permissionKey: 'Order',
  productType: 'FlightOrder',
  route: {
    index: 'Orders',
    create: 'CreateOrderBudgetGroupingFlight',
    edit: 'EditOrderBudgetGroupingFlight',
  },
  param: 'orderFlight',
  singular: 'Flight',
  plural: 'Flights',
  parentSingular: 'Order',
  parentPlural: 'Orders',
  statusKey: 'flightOrderStatusType',
  statusList: ['Draft', 'Pending', 'Archived', 'Paused', 'Converted'],
  list: {
    search: '',
    headers: [
      {
        key: 'gap-1',
        pages: [1, 2, 3],
        heading: null,
        size: '1rem',
        classCell:
          'tw-h-20 tablet:tw-h-18 tw-bg-alto-light tw-border-l tw-border-border',
        classHeader: 'tw-hidden',
      },
      {
        key: 'gap-2',
        pages: [1, 2, 3],
        heading: null,
        size: '1rem',
        classCell:
          'tw-h-20 tablet:tw-h-18 tw-bg-pill-bg tw-border-l tw-border-border',
        classHeader: 'tw-hidden',
      },
      {
        label: 'Status',
        key: 'flightOrderStatusType',
        pages: [1, 2, 3],
        componentHeader: 'ListHeaderStatus',
        componentList: 'ListCellTypeIcon',
        icon: 'plane',
        size: '90px',
        classCell:
          'tw-h-20 tablet:tw-h-18 tw-border-l tw-border-border tw-justify-end tw-pr-4',
        classHeader: 'tw-col-span-2',
      },
      {
        label: 'Name',
        key: 'name',
        pages: [1, 2, 3],
        componentHeader: 'ListHeaderDefault',
        componentList: 'ListCellEntityName',
        size: 'minmax(100px, 1fr)',
        classCell: 'tw-h-20 tablet:tw-h-18',
      },
      {
        label: 'Start date',
        key: 'startDate',
        pages: [1],
        componentHeader: 'ListHeaderDefault',
        componentList: 'ListCellDate',
        size: '150px',
        classCell: 'tw-h-20 tablet:tw-h-18 tw-px-2',
        classHeader: 'tw-px-2',
      },
      {
        label: 'End date',
        key: 'endDate',
        pages: [1],
        componentHeader: 'ListHeaderDefault',
        componentList: 'ListCellDate',
        size: '150px',
        classCell: 'tw-h-20 tablet:tw-h-18 tw-px-2',
        classHeader: 'tw-px-2',
      },
      {
        label: 'Ordered',
        key: 'budget.orderedImpressions',
        pages: [2],
        componentHeader: 'ListHeaderRange',
        componentList: 'ListCellEmpty',
        size: '120px',
        classCell: 'tw-h-20 tablet:tw-h-18 tw-px-2 tw-justify-end',
        classHeader: 'tw-px-2 tw-justify-end',
      },
      {
        label: 'Gross CPM',
        key: 'budget.grossCpm',
        pages: [2],
        componentHeader: 'ListHeaderRange',
        componentList: 'ListCellEmpty',
        size: '120px',
        classCell: 'tw-h-20 tablet:tw-h-18 tw-px-2 tw-justify-end',
        classHeader: 'tw-px-2 tw-justify-end',
      },
      {
        label: 'Actions',
        key: 'actions',
        pages: [1, 2, 3],
        componentHeader: 'ListHeaderPagination',
        componentList: 'ListCellActions',
        size: '80px',
        classCell:
          'tw-h-20 tablet:tw-h-18 tw-border-l tw-border-r tw-border-border',
        classHeader: 'tw-col-span-3',
      },
      {
        key: 'gap-3',
        pages: [1, 2, 3],
        heading: null,
        size: '1rem',
        classCell:
          'tw-h-20 tablet:tw-h-18 tw-bg-pill-bg tw-border-r tw-border-border',
        classHeader: 'tw-hidden',
      },
      {
        key: 'gap-4',
        pages: [1, 2, 3],
        heading: null,
        size: '1rem',
        classCell:
          'tw-h-20 tablet:tw-h-18 tw-bg-alto-light tw-border-r tw-border-border',
        classHeader: 'tw-hidden',
      },
    ],
    filtersCallbacks: {
      status(item, selectedStatus) {
        return (
          selectedStatus.length === 0 ||
          selectedStatus.includes(item.flightOrderStatusType)
        )
      },
      impressionsGoal(item, { min, max }) {
        return (
          (min !== null ? item.impressionsGoal >= min : true) &&
          (max !== null ? item.impressionsGoal <= max : true)
        )
      },
      grossCpm(item, { min, max }) {
        return (
          (min !== null ? item.grossCpm >= min : true) &&
          (max !== null ? item.grossCpm <= max : true)
        )
      },
    },
    rowOptions: (item) => {
      const options = [
        {
          key: 'copyWorkId',
          label: `Copy Work ID (${item.workId})`,
          iconLabel: `${item.workId}`,
          text: item.workId,
          icon: 'copy',
        },
        {
          key: 'duplicate',
          label: 'Duplicate',
          icon: 'copy',
        },
        ...(['Draft'].includes(item.flightOrderStatusType)
          ? [
              {
                key: 'delete',
                label: 'Delete',
                icon: 'trash',
              },
            ]
          : []),
        {
          key: 'edit',
          label: 'Edit',
          icon: 'edit',
        },
      ]

      return options
    },
  },
  mutationsToWatch: [],
  moreActions: (item) => {
    if (!item) {
      return []
    }

    const bundles = store.state.bundles.list

    const actions = [
      {
        key: 'duplicate',
        label: `Duplicate`,
        icon: 'copy',
      },
      {
        key: 'divider-2',
        divider: true,
      },
      {
        key: 'load-bundle',
        label: 'Load Bundle',
        children: bundles.length
          ? bundles.map((bundle) => {
              return {
                key: 'load-bundle',
                label: bundle.name,
                id: bundle.id,
                targetingFilterId: item.targetingFilterId,
                icon: bundle.isShared ? 'gender-both' : null,
                iconTooltip: 'Shared',
              }
            })
          : [{ key: 'no-bundle', label: 'No Bundle available' }],
      },
      {
        key: 'save-bundle',
        label: 'Save As Bundle',
        permission: 'CreateBundle',
      },
      {
        key: 'manage-bundles',
        label: 'Manage Bundles',
        permission: 'CreateBundle',
      },
      ...(['Draft'].includes(item.flightOrderStatusType)
        ? [
            {
              key: 'divider-3',
              divider: true,
            },
            {
              key: 'delete',
              label: `Delete`,
              icon: 'trash',
              class: 'hover:tw-text-red',
            },
          ]
        : []),
    ]

    return actions
  },
  shouldUpdateDmps(form, item) {
    if (form.startDate !== item.startDate || form.endDate !== item.endDate) {
      return true
    }

    return false
  },
  handleStoreInput(module, path, value, valueKey = 'form') {
    store.dispatch(`${module}/handleInput`, { path, value, valueKey })
  },
  getDescription(item) {
    return `<div class="tw-flex tw-flex-col tw-space-y-4">
      <div class="tw-flex tw-flex-col">
        <div class="tw-font-semibold tw-text-sm">Name</div>
        <div class="tw-text-sm">${item.name}</div>
      </div>
      <div class="tw-flex tw-flex-col">
        <div class="tw-font-semibold tw-text-sm">Dates</div>
        <div class="tw-text-sm">${formatDate(item.startDate)} - ${
      item.endDate ? formatDate(item.endDate) : '-'
    }</div>
      </div>
    </div>`
  },
}

export default entity
